import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import VueVisible from 'vue-visible'

import VeeValidate from 'vee-validate' // 表單驗證
import 'bootstrap'
import VueI18n from 'vue-i18n'
import zhTW from 'vee-validate/dist/locale/zh_TW'
import en from 'vee-validate/dist/locale/en'
import VueSweetalert2 from 'vue-sweetalert2' //彈跳視窗
import 'sweetalert2/dist/sweetalert2.min.css'
import VueTelInput from 'vue-tel-input' // 國際電話
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay' // 瀏覽樣式
import 'vue-loading-overlay/dist/vue-loading.css'
import VueAnalytics from 'vue-analytics'
import './bus' // 將bus.vue直接掛在Vue主元件的下面

Vue.use(VueVisible)

Vue.use(CoolLightBox)
Vue.use(VueMeta)
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
Vue.use(VueSweetalert2)
Vue.use(VueTelInput)
Vue.use(VueCookies)
Vue.component('Loading', Loading) // 全域啟用瀏覽中loading的樣式

Vue.use(Loading, {
  // props
  width: 14,
  height: 14,
  backgroundColor: '#00DB00',
  opacity: 1,
  zIndex: 999,
  canCancel: false,
  color: '#00DB00',
})

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'en',
})

Vue.use(VeeValidate, {
  events: 'input|blur',
  validity: true,
  aria: true,
  i18n,
  dictionary: {
    zhTW,
    en,
  },
})

Vue.use(VueAnalytics, {
  id: ['UA-46360745-26', 'UA-193456801-62'],
  router,
})

new Vue({
  router,
  store,
  i18n,

  render: (h) => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.requiresAuth) {
    if (to.name !== 'Login' && to.name !== 'Registration' && to.name !== 'Signup') {
      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`

      Vue.axios.post(api).then((response) => {
        if (response.data == 200) {
          sessionStorage.setItem('access', '200')
          const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/0A5A5A7BBB26EBBC5166A2F2DE7F0CA4`

          Vue.axios.post(registerApi).then((response) => {
            if (response.data == 200) {
              next()
            } else if (response.data == 252) {
              alert('Please complete the questionnaire to finish the visit registration')
              next({
                path: '/Registration',
              })
            } else if (response.data == 251) {
              window.location.replace(`https://www.chanchao.com.tw/en/`)
            } else if (response.data == 253) {
              next()
            } else if (response.data == 254) {
              next()
            }
          })
        } else {
          //251 的狀態
          sessionStorage.setItem('access', '')
          sessionStorage.removeItem('access')
          next({
            path: '/Landing',
          })
        }
      })
    } else if (to.name == 'Login') {
      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
      Vue.axios.post(api).then((response) => {
        if (response.data == 200) {
          alert('You are already logged in.')
        } else {
          next()
        }
      })
    } else if (to.name == 'Registration') {
      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
      Vue.axios.post(api).then((response) => {
        if (response.data == 200) {
          const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/0A5A5A7BBB26EBBC5166A2F2DE7F0CA4`
          Vue.axios.post(registerApi).then((response) => {
            if (response.data == 200) {
              alert('You are already registered .')
            } else if (response.data == 252) {
              next()
            } else if (response.data == 251) {
              window.location.replace(`https://www.chanchao.com.tw/en/`)
            } else if (response.data == 253) {
              next()
            } else if (response.data == 254) {
              next()
            }
          })
        } else {
          next({
            path: '/Landing',
          })
        }
      })
    } else if (to.name == 'Signup') {
      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
      Vue.axios.post(api).then((response) => {
        if (response.data == 200) {
          alert('You are already logged in.')
        } else {
          next()
        }
      })
    }
  } else {
    next()
  }
})
